import React from "react";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import BRSRSidebar from "../../../../Layout/BRSRSidebar";
import Principle7 from "./Principle7";

const index = () => {
  return (
    <MainDashboardLayout sidebar={<BRSRSidebar />}>
      <Principle7 />
    </MainDashboardLayout>
  );
};

export default index;
